// ============================================================
//  Finkraft GST Platform — Light Theme (Blue-Green)
//  Palette matches the Finkraft logo's cyan "k" accent.
// ============================================================

export const C = {
  // Base surfaces
  bg:        '#F1F7FA',
  bgDeep:    '#E6F1F5',
  surface:   '#FFFFFF',
  surface2:  '#F6FAFC',
  surface3:  '#ECF3F7',

  // Borders
  border:    'rgba(15,23,42,0.06)',
  border2:   'rgba(15,23,42,0.10)',
  borderStrong: 'rgba(15,23,42,0.16)',

  // Text
  text:      '#0F172A',
  textSoft:  '#334155',
  muted:     '#64748B',
  mutedSoft: '#94A3B8',

  // Primary accent — Finkraft teal/cyan ("k")
  accent:    '#0891B2',
  accent2:   '#0E7490',
  accent3:   '#06B6D4',
  accentBg:  'rgba(8,145,178,0.08)',
  accentBgStrong: 'rgba(8,145,178,0.14)',

  // Secondary — teal
  teal:      '#14B8A6',
  tealBg:    'rgba(20,184,166,0.10)',

  // Status colors
  success:   '#059669',
  successBg: 'rgba(5,150,105,0.10)',
  warn:      '#D97706',
  warnBg:    'rgba(217,119,6,0.10)',
  danger:    '#DC2626',
  dangerBg:  'rgba(220,38,38,0.08)',

  // Dark panels (kept for SQL editor contrast)
  codeBg:    '#0F1B2D',
  codeText:  '#7DD3FC',
};

export const radius = { sm: '6px', md: '10px', lg: '14px', xl: '18px' };

export const shadow = {
  xs: '0 1px 2px rgba(15,23,42,0.04)',
  sm: '0 1px 3px rgba(15,23,42,0.06), 0 1px 2px rgba(15,23,42,0.04)',
  md: '0 4px 12px rgba(15,23,42,0.06), 0 1px 3px rgba(15,23,42,0.04)',
  lg: '0 12px 28px rgba(15,23,42,0.08), 0 4px 10px rgba(15,23,42,0.04)',
  glow: '0 0 0 4px rgba(8,145,178,0.12)',
};

export const sev = {
  High:   { bg: '#FEE2E2', color: '#991B1B' },
  Medium: { bg: '#FEF3C7', color: '#92400E' },
  Low:    { bg: '#ECFDF5', color: '#065F46' },
};

export const card = {
  background: C.surface,
  border: `1px solid ${C.border2}`,
  borderRadius: radius.lg,
  padding: '20px 22px',
  boxShadow: shadow.sm,
};

export const inlineStyles = {
  globalCSS: `
    @keyframes spin { to { transform: rotate(360deg); } }
    @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:.35} }
    @keyframes slideUp { from{transform:translateY(10px);opacity:0} to{transform:translateY(0);opacity:1} }
    @keyframes fadeIn { from{opacity:0} to{opacity:1} }
    @keyframes progressBar { from{width:0%} to{width:100%} }
  `,
};